import { render } from "./application_attributes.html?vue&type=template&id=8e32c18e&scoped=true&external"
import script from "./application_attributes.js?vue&type=script&lang=js&external"
export * from "./application_attributes.js?vue&type=script&lang=js&external"

import "./ApplicationAttributes.vue?vue&type=style&index=0&id=8e32c18e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e32c18e"]])

export default __exports__